import store from '@/store'
import * as apiCommon from '@/api/common'
import * as apiGA from '@/api/ga'
    
const qa = {
  namespaced: true,
  state: {
    fromNameForQAList: '', // QA一覧に対する遷移元の名前

    idMapListOfCheckedBooks: [], // 簡易検索用：チェックされている書籍の商品IDと書籍IDのリスト（詳細から戻った時の復元用）

    selectedListItemId: 0, // 詳細画面から一覧画面に戻ってきた時のスクロール位置指定用ID (QAID)

    // 詳細検索実行フラグ(false:簡易検索、true:詳細検索)
    // 詳細検索ウィンドウから実行された場合、ページネーション時に詳細検索を実行するか判断するのに使用する
    // 詳細検索ウィンドウで検索実行時にtrueに設定される
    isSearchDetail: false,

    // 現在の書籍ID
    bookId: 0,
    // 現在の書籍名
    bookName: '',
    // 現在のQA ID
    qaId: 0,
    // 現在の検索インデックスID
    searchIndexId: 0,
    // 現在のリビジョン名
    revisionName: '最新',
    // 書籍リビジョンID（管理システムの書籍プレビュー処理でのみ使用）
    bookRevisionId: 0,

    // ノート用ID
    noteId: 0,
    // ノート用行ID
    noteRowId: 0,

    // 表示しているページ（詳細画面から戻ってきたときに対象ページ表示用）
    page: 1,

    // 表示設定：1ページ当たりの表示件数
    list_per_page: 30,
    // 表示設定：一覧画面の非表示項目
    list_hidden_keys: [],
    // 並び順設定：並び順（score=関連度順、book=書籍順）
    list_order: 'score',

    numberCarouselVisible: 0, // 表示中のカルーセルのスライド番号(SP用)

    // QAコード
    qaCode: '',
    // 書籍コード
    bookCode: '',
    // 商品コード
    product_codes: [],

    // 遷移元
    referrer: null,

    // 遷移元URL
    prev_url: null
  },
  getters: {
  },
  mutations: {
    // QA一覧に対する遷移元の名前
    setFromNameForQAList(state, fromNameForQAList) {
      state.fromNameForQAList = fromNameForQAList
    },
    clearAll(state) {
      state.idMapListOfCheckedBooks = []
      state.isSearchDetail = false
      state.bookId = 0
      state.bookName = ''
      state.qaId = 0
      state.searchIndexId = 0
      state.revisionName = '最新'
      state.bookRevisionId = 0
      state.noteId = 0
      state.noteRowId = 0
      state.page = 1
      state.list_per_page = 30
      state.list_hidden_keys = []
      state.list_order = 'book'
    },

    setIdMapListOfCheckedBooks(state, idMapListOfCheckedBooks) {
      state.idMapListOfCheckedBooks = idMapListOfCheckedBooks
    },

    setSelectedListItemId(state, selectedListItemId) {
      state.selectedListItemId = selectedListItemId
    },    

    setSearchDetail(state, isSearchDetail) {
      state.isSearchDetail = isSearchDetail
    },

    setBookId(state, bookId) {
      state.bookId = bookId
    },
    setBookName(state, bookName) {
      state.bookName = bookName
    },
    setQaId(state, qaId) {
      state.qaId = qaId
    },
    setSearchIndexId(state, searchIndexId) {
      state.searchIndexId = searchIndexId
    },
    setRevisionName(state, revisionName) {
      state.revisionName = revisionName
    },
    setBookRevisionId(state, bookRevisionId) {
      state.bookRevisionId = bookRevisionId
    },
    setNoteId(state, noteId) {
      state.noteId = noteId
    },
    setNoteRowId(state, noteRowId) {
      state.noteRowId = noteRowId
    },
    setPage(state, page) {
      state.page = page
    },
    setListDisplaySettings(state, { perPage, hiddenKeys }) {
      state.list_per_page = perPage
      state.list_hidden_keys = hiddenKeys
    },
    setListOrderSettings(state, order) {
      state.list_order = order
    },

    setNumberCarouselVisible(state, numberCarouselVisible) {
      state.numberCarouselVisible = numberCarouselVisible
    },

    setQaCode(state, qaCode) {
      state.qaCode = qaCode
    },
    setBookCode(state, bookCode) {
      state.bookCode = bookCode
    },
    setProductCodes(state, productCodes) {
      state.product_codes = productCodes
    },
    setReferrer(state, referrer) {
      state.referrer = referrer
    },
    setPrevUrl(state, url) {
      state.prev_url = url
    }
  },
  actions: {
    // QA一覧に対する遷移元の名前
    setFromNameForQAList({ commit }, fromNameForQAList) {
      commit('setFromNameForQAList', fromNameForQAList)
    },
    
    // 全ステートをクリア
    clearAll({ commit }) {
      commit('clearAll')
    },
    setIdMapListOfCheckedBooks({ commit }, idMapListOfCheckedBooks) {
      commit('setIdMapListOfCheckedBooks', idMapListOfCheckedBooks)
    },

    setSelectedListItemId({ commit }, selectedListItemId) {
      commit('setSelectedListItemId', selectedListItemId)
    },

    // 詳細検索実行フラグ
    setSearchDetail({ commit }, isSearchDetail) {
      commit('setSearchDetail', isSearchDetail)
    },

    // 書籍ID
    setBookId({ commit }, bookId) {
      commit('setBookId', bookId)
    },
    // 書籍名
    setBookName({ commit }, bookName) {
      commit('setBookName', bookName)
    },
    // QA ID
    setQaId({ commit }, qaId) {
      commit('setQaId', qaId)
    },
    // 検索インデックID
    setSearchIndexId({ commit }, searchIndexId) {
      commit('setSearchIndexId', searchIndexId)
    },
    // リビジョン名
    setRevisionName({ commit }, revisionName) {
      commit('setRevisionName', revisionName)
    },
    // 書籍リビジョンID
    setBookRevisionId({ commit }, bookRevisionId) {
      commit('setBookRevisionId', bookRevisionId)
    },
    // ノート用 NOTE ID
    setNoteId({ commit }, noteId) {
      commit('setNoteId', noteId)
    },
    // ノート用 ROW ID
    setNoteRowId({ commit }, noteRowId) {
      commit('setNoteRowId', noteRowId)
    },
    // 表示しているページ
    setPage({ commit }, page) {
      commit('setPage', page)
    },
    
    // 表示設定
    setListDisplaySettings({ commit }, { perPage, hiddenKeys }) {
      commit('setListDisplaySettings', { perPage, hiddenKeys })
    },
    // 並び順の設定
    setListOrderSettings({ commit }, order) {
      commit('setListOrderSettings', order)
    },
    /**
     *  表示設定、並び順設定を保存する
     */
    saveListSettings({ commit }, { callback }) {

      // 利用者設定更新APIをコール
      const params = {}
      if (store.state.common.device === 'sp') {
        params.setting_key = 'sp_qa_order_disp_settings'
      } else {
        params.setting_key = 'pc_qa_order_disp_settings'
      }
      const listSettings = {}
      listSettings.per_page = store.state.qa.list_per_page
      listSettings.hidden_keys = store.state.qa.list_hidden_keys
      listSettings.order = store.state.qa.list_order

      params.setting_value = JSON.stringify(listSettings)

      apiCommon.updateUserSetting(params)
        .then(response => {
          if (response) {
            const { data } = response

            callback() 
          }
        })
    },

    // 表示中のカルーセルのスライド番号(SP用)
    setNumberCarouselVisible({ commit }, numberCarouselVisible) {
      commit('setNumberCarouselVisible', numberCarouselVisible)
    },
    // GA登録情報取得
    async getQaInfo({ commit, state }, id) {
      const params = {
        qa_id: id
        // key: 'qa_id'
      }
      await apiGA
        .gaQaInfo(params)
        .then(response => {
          const { data } = response
          commit('setQaCode', data.qa_code)
          commit('setBookCode', data.book_code)
          commit('setProductCodes', data.product_codes)
        })
    },
    // 遷移元設定
    setReferrerObject({ commit }, obj) {
      commit('setReferrer', obj)
    },
    // 遷移元URL設定
    setPrevUrlStr({ commit }, url) {
      commit('setPrevUrl', url)
    }
  }
}

export default qa
